import TianDingCheckRadioComponent from "./checkRadio.vue";

export default {
  install(Vue, PluginOptions = {}) {
    const Constructor = Vue.extend(TianDingCheckRadioComponent);
    Vue.component('td-check-radio', Constructor);
  }
}



// WEBPACK FOOTER //
// ./src/_components/checkRadio/index.js